'use strict'

module.exports = {
  TEXT_MAP: 'text_map',
  HTTP_HEADERS: 'http_headers',
  BINARY: 'binary',
  LOG: 'log',
  TEXT_MAP_DSM: 'text_map_dsm'
}
